
import { defineComponent } from 'vue'
import CLogisticOfferList from '@invivodf/common/src/contexts/logistic-offer/application/components/CLogisticOfferList/CLogisticOfferList.vue'

export default defineComponent({
  name: 'VLogisticOfferList',
  components: { CLogisticOfferList },
})
